import styled from "styled-components"

import Modal, { ModalButtons, ModalText, ModalTitle } from "~/themes/original/components/Modal"
import { query } from "~/utilities/trpc"

import Button from "../Button"
import PartialLoadingPage from "../PartialLoadingPage"
import Reaction from "./Reaction"

const PostReactions: React.FC<{ postId: number | null; onClose(): void }> = ({ postId, onClose }) => {
	const { data: reactions, error } = query.community.listPostReactions.useQuery(postId!, { enabled: postId !== null })

	return (
		<Modal isOpen={postId !== null}>
			<ModalTitle>Likes</ModalTitle>
			{reactions === undefined ? (
				<PartialLoadingPage />
			) : error ? (
				<ModalText>Failed to load likes.</ModalText>
			) : (
				<Reactions>
					{reactions.map(reaction => (
						<Reaction key={reaction.profile.id} reaction={reaction} />
					))}
				</Reactions>
			)}
			<ModalButtons>
				<Button variant="primary" onClick={onClose}>
					Close
				</Button>
			</ModalButtons>
		</Modal>
	)
}

const Reactions = styled.div`
	flex: 1 1 auto;
	display: flex;
	flex-direction: column;
	gap: 8px;
	overflow-y: scroll;
`

export default PostReactions
